import { createSlice, current } from '@reduxjs/toolkit';
import {
	getRestitutionCoordinatesList,
	getRestitutionCoordinatesItem,
	addNewRestitutionCoordinates,
	updateRestitutionCoordinates,
	deleteRestitutionCoordinates,
} from './thunk';

export const initialState = {
	itemRestitutionCoordinatesList: [],
	itemRestitutionCoordinates: null,
	isRestitutionCoordinatesLoading: false,
	isRestitutionCoordinatesSuccess: false,
	statementList: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const RestitutionCoordinatesSlice = createSlice({
	name: 'RestitutionCoordinates',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		clearRestitutionCoordinates(state) {
			state.itemRestitutionCoordinatesList = [];
			state.statementList = [];
		},
	},
	extraReducers: builder => {
		builder.addCase(getRestitutionCoordinatesList.pending, state => {
			state.isLoadingList = true;
			state.isRestitutionCoordinatesSuccess = false;
		});

		builder.addCase(getRestitutionCoordinatesList.fulfilled, (state, action) => {
			state.itemRestitutionCoordinatesList = action.payload;
			state.statementList = action.payload;
			state.isLoadingList = false;
			state.isRestitutionCoordinatesSuccess = true;
		});

		builder.addCase(getRestitutionCoordinatesList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isRestitutionCoordinatesSuccess = false;
		});

		builder.addCase(getRestitutionCoordinatesItem.pending, state => {
			state.isRestitutionCoordinatesLoading = true;
			state.isRestitutionCoordinatesSuccess = false;
		});

		builder.addCase(getRestitutionCoordinatesItem.fulfilled, (state, action) => {
			state.itemRestitutionCoordinates = action.payload;
			state.isRestitutionCoordinatesLoading = false;
			state.isRestitutionCoordinatesSuccess = true;
		});

		builder.addCase(getRestitutionCoordinatesItem.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isRestitutionCoordinatesLoading = false;
			state.isRestitutionCoordinatesSuccess = false;
		});

		builder.addCase(addNewRestitutionCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewRestitutionCoordinates.fulfilled, (state, action) => {
			state.itemRestitutionCoordinatesList.push(action.payload);
			state.statementList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewRestitutionCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateRestitutionCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateRestitutionCoordinates.fulfilled, (state, action) => {
			state.itemRestitutionCoordinatesList = state.itemRestitutionCoordinatesList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateRestitutionCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteRestitutionCoordinates.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteRestitutionCoordinates.fulfilled, (state, action) => {
			state.itemRestitutionCoordinatesList = current(state.itemRestitutionCoordinatesList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteRestitutionCoordinates.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal, clearRestitutionCoordinates } = RestitutionCoordinatesSlice.actions;

export default RestitutionCoordinatesSlice.reducer;
